$(function() {

    $(".aside-tabs__item").click(function() {
       $(".aside-tabs__item").removeClass("active");
       $(this).addClass("active");

       var dataTab = $(this).attr("data-tab");
       $(".tab-content").each(function() {
           var dataItem = $(this).attr("data-tab-content");
            if ( dataItem.indexOf(dataTab) !== -1 ) {
                $(this).show();
            }else{
                $(this).hide();
            }
       });
    });

    $(".faq__item-title").click(function() {
        $(this).siblings(".faq__item-text").slideToggle();
        $(this).closest(".faq__item").toggleClass("active");
    });

});